import { Component, OnInit, HostListener, OnDestroy, AfterContentInit } from '@angular/core';
import { UiService } from '../../ui.service';
import { homePage, sliderPage } from '../../animation/animate';
import { AppServiceService } from '../../app-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { WindowService } from '../../window.service';
declare var api_settings: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [homePage, sliderPage],
  host: { '[@homePage]': '' }
})
export class HomeComponent implements OnInit, OnDestroy, AfterContentInit {
  private ngUnsubscribe: Subject<boolean> = new Subject();

  @HostListener('window:beforeunload')
  doSomething() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }


  private stateSlider:string = 'hide';
  private mobile: boolean = false;
  private post:any;
  public theme:any = {
    'social' : {
      'facebook' : '',
      'instagram': ''
    }
  };
  private mask:string;
  private window:any;

  constructor(
    private UI: UiService,
    private app: AppServiceService,
    private router: Router,
    private route: ActivatedRoute,
    private nativeWindow: WindowService) {
    //load data 
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.post   = data.data;
      this.theme  = data.theme;
    });
    this.window = this.nativeWindow.nativeWindow();

    if(window.location.hash != '#home'){
      window.scrollTo(0, 0);
      this.UI.activePreloader();
    }

    //load page on top
    
    //black style color text menu
    this.app.blackStyle.next(false);
    //show arrow left panel
    this.app.arrow.next(true);
    //show external button left panel
    this.app.externalButton.next(false);
    //state main menu
    this.app.normalMenu.next(true);
    //state animate
    this.app.stateSlider.next('hide');
  }

  trackByFn(index, item) {
    return index; // or item.id
  }

  moveTo(event: Event, link) {
    event.preventDefault();
    event.stopPropagation();
    this.router.navigate([link]);
  }

  cutUrl(url:string){
    let mass = url.split('/');
    return mass[mass.length - 1];
  }

  ngOnInit(){     
    if(window.location.hash == '#home'){
      setTimeout(() => {
        this.UI.moveHomeSection();
      }, 700);
      
    }

    if(window.location.hash != '#home'){
      setTimeout(() => {
        this.app.title.next(this.post.title);
        this.UI.slideCollection('.homeCollection', true);
        this.UI.mainHomeSlider();
        this.UI.scrollEventHome();
      }, 500);
    }else{
      setTimeout(() => {
        this.UI.slideCollection('.homeCollection', true);
      },500);
    }

    this.mobile = this.UI.widthMobile();
    this.mask = this.mobile ? this.post.main_slider.mask_mobile : this.post.main_slider.mask;
    setTimeout(() => {
      this.app.title.next(this.post.title);
    }, 500);
    this.app.showLeftPanel.next(false);
    
    

    this.app.stateSlider.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.stateSlider = data;
    })
  }

  ngAfterContentInit(){
    setTimeout(() => {
      this.UI.removePreloader();
    }, 4000);
  }

  ngOnDestroy() {
    this.app.titleLeftPanel.next(false);

    this.app.activeMenu.next(false);
    this.app.blackStyle.next(false);
    this.app.menuState.next('hide');
    this.app.submenuState.next('hide');

    setTimeout(() => {
      this.app.title.next('');
    }, 500);
    
    //unsabscribe
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home/home.component.ts